"use strict";
/*
 * Created on 1. 11. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var ValidationResultConverter_1 = require("../../core/model/errors/conversions/ValidationResultConverter");

var ValidationResult_1 = require("../../core/model/errors/ValidationResult");

var utils_1 = require("../../core/utils");

var OptimalPrice_1 = require("../model/OptimalPrice");

var OptimalPriceConverter_1 = require("./OptimalPriceConverter");
/**
 * @author Radek Beran
 */


var OptimalPriceConverterImpl =
/*#__PURE__*/
function (_OptimalPriceConverte) {
  _inherits(OptimalPriceConverterImpl, _OptimalPriceConverte);

  function OptimalPriceConverterImpl(validationResultConverter) {
    var _this;

    _classCallCheck(this, OptimalPriceConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(OptimalPriceConverterImpl).call(this));
    _this.validationResultConverter = validationResultConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(OptimalPriceConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new OptimalPrice_1.OptimalPrice(utils_1.Utils.isValueMissing(source.value) ? null : conversions.toBigNumber(source.value), utils_1.Utils.isValueMissing(source.valueRounded) ? null : OptimalPrice_1.OptimalPrice.schema.valueRounded.valueOf(conversions.toBigNumber(source.valueRounded)), conversions.toBigNumber(source.rangeMin), conversions.toBigNumber(source.rangeMax), utils_1.Utils.isValueMissing(source.repricingImportance) ? null : conversions.toBigNumber(source.repricingImportance), !utils_1.Utils.isValueMissing(source.forecastOld) ? conversions.toBigNumber(source.forecastOld) : null, !utils_1.Utils.isValueMissing(source.forecastNew) ? conversions.toBigNumber(source.forecastNew) : null, utils_1.Utils.isValueMissing(source.validationResult) ? ValidationResult_1.ValidationResult.EMPTY : this.validationResultConverter.toObject(source.validationResult, conversions));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var result = {};
      Object.assign(result, {
        value: source.value !== null ? conversions.fromBigNumber(source.value) : null,
        valueRounded: source.valueRounded !== null ? conversions.fromBigNumber(source.valueRounded) : null,
        rangeMin: conversions.fromBigNumber(source.rangeMin),
        rangeMax: conversions.fromBigNumber(source.rangeMax),
        repricingImportance: source.repricingImportance !== null ? conversions.fromBigNumber(source.repricingImportance) : null,
        forecastOld: source.forecastOld !== null ? conversions.fromBigNumber(source.forecastOld) : null,
        forecastNew: source.forecastNew !== null ? conversions.fromBigNumber(source.forecastNew) : null,
        validationResult: this.validationResultConverter.toDocument(source.validationResult, conversions)
      });
      return result;
    }
  }]);

  return OptimalPriceConverterImpl;
}(OptimalPriceConverter_1.OptimalPriceConverter);

OptimalPriceConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [ValidationResultConverter_1.ValidationResultConverter])], OptimalPriceConverterImpl);
exports.OptimalPriceConverterImpl = OptimalPriceConverterImpl;